import VoiceRepository from '@/repositories/VoiceRepository'
import PagerRepository from '@/repositories/PagerRepository'
import ContentfulGateway from '@/gateways/ContentfulGateway'

export interface IFetchVoicesUseCaseParams {
  voiceRepository: VoiceRepository
  pagerRepository: PagerRepository
  contentfulGateway: ContentfulGateway
}

export default class FetchVoicesUseCase implements BaseUseCase {
  voiceRepository: VoiceRepository
  pagerRepository: PagerRepository
  contentfulGateway: ContentfulGateway

  constructor({ voiceRepository, contentfulGateway, pagerRepository }: IFetchVoicesUseCaseParams) {
    this.voiceRepository = voiceRepository
    this.pagerRepository = pagerRepository
    this.contentfulGateway = contentfulGateway
  }

  async execute(params: { page?: number; perPage?: number }) {
    try {
      const { page, perPage } = params
      const { voices, total } = await this.contentfulGateway.getVoices(params)
      this.voiceRepository.saveVoicesByPage({ voices, page: page || 1 })
      this.pagerRepository.updateVoicesPager({ page, size: perPage, total })
    } catch (error) {
      throw error
    }
  }
}
